import { selectSalesIntelligenceState } from "app/pages/sales-intelligence/store/selectors";
import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";

const selectCompanyAnalysisSlice = createStatePropertySelector(selectSalesIntelligenceState("companyAnalysis"));
export const selectContactsSlice = selectCompanyAnalysisSlice("contacts");
export const selectCompetitorsSlice = selectCompanyAnalysisSlice("competitors");
